/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  ADD_SERIAL_NO: {},
};

const MACHINE_CONFIG = {
  id: "io.vlinder.gems.printLabel.addSerialNo",
  initial: "idle",
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ["resetAction"],
      on: {
        MUTATE: { target: "ADD_SERIAL_NO" },
      },
    },
    ADD_SERIAL_NO: {
      invoke: {
        id: "addSerialNo",
        src: "addSerialNo",
        onDone: {
          target: "ADD_SERIAL_NO_SUCCESS",
          actions: ["successAction"],
        },
        onError: {
          target: "ADD_SERIAL_NO_FAILED",
          actions: ["failureAction"],
        },
      },
    },
    ADD_SERIAL_NO_SUCCESS: {
      on: {
        MUTATE: { target: "ADD_SERIAL_NO" },
      },
    },
    ADD_SERIAL_NO_FAILED: {
      on: {
        MUTATE: { target: "ADD_SERIAL_NO" },
      },
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
